// ERP tizimlari — xizmat sahifasi kontenti (Innobek)
// SEO: "ERP tizim", "ERP yaratish", "korxona boshqaruv tizimi", "ombor dasturi",
// "ishlab chiqarish hisobi", "1C integratsiya", "tannarx hisobi".
// Asosiy xabar: ombor, ishlab chiqarish va moliya — yagona bazada, bosqichma-bosqich.

const uz = {
    meta: {
        title: "ERP tizimlari — ombor, ishlab chiqarish va moliya bitta tizimda",
        description:
            "ERP tizimlari ishlab chiqish: ombor, ishlab chiqarish, moliya va hisobot yagona bazada. 40 mln so'mdan, modullar bosqichma-bosqich, 1C bilan integratsiya.",
        keywords: [
            "ERP tizimlari",
            "ERP yaratish",
            "korxona boshqaruv tizimi",
            "ombor dasturi",
            "ishlab chiqarish hisobi dasturi",
            "tannarx hisobi",
            "1C integratsiya",
            "ERP narxi",
            "ERP Toshkent",
        ],
    },

    hero: {
        eyebrow: "ERP tizimlari",
        h1: "ERP tizimlari — ombor, ishlab chiqarish va moliya yagona tizimda",
        lead:
            "Sotuv Excel'da, ombor daftarda, buxgalteriya 1C'da turibdimi? ERP butun korxonani bitta bazaga yig'adi: xariddan omborga, ishlab chiqarishdan sotuvga va moliyagacha. Har bir raqam bir marta kiritiladi va hamma bo'limda bir xil ko'rinadi.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "Modullar bosqichma-bosqich ishga tushadi",
            "1C va bank bilan integratsiya",
            "Kod va baza to'liq sizniki",
        ],
    },

    intro: {
        h: "ERP tizimi nima va u korxonaga nima beradi?",
        p: [
            "ERP (Enterprise Resource Planning) — korxonaning barcha resurslarini bitta dasturda boshqaradigan tizim. CRM faqat mijoz va sotuv bilan ishlasa, ERP undan kengroq: xaridlar, ombor, ishlab chiqarish, moliya, kadrlar va hisobot bitta ma'lumotlar bazasida bog'langan holda yuritiladi.",
            "Ko'p korxonada bugungi holat shunday ko'rinadi. Sotuv bo'limi Excel jadvalida ishlaydi, ombor daftar yoki alohida dasturda hisob yuritadi, buxgalteriya 1C'da o'tiradi, ishlab chiqarish esa usta boshining xotirasiga tayanadi. Natijada har bir hisobot qo'lda yig'iladi, raqamlar bir-biriga mos kelmaydi va rahbar qaror qabul qilish uchun uch kun kutadi.",
            "ERP aynan shu bo'shliqni yopadi. Ombordan tovar chiqqanda qoldiq o'zi kamayadi, ishlab chiqarishga xom ashyo berilganda tannarxga o'zi yoziladi, mijoz to'laganda qarzdorlik o'zi yopiladi. Hech kim bitta raqamni ikkinchi jadvalga ko'chirmaydi — demak, ko'chirishda xato ham qilinmaydi.",
            "Innobek tayyor «qutidagi» ERP sotmaydi. Biz korxonangizning haqiqiy jarayonini o'rganib, tizimni shunga moslab quramiz va modullarni bosqichma-bosqich ishga tushiramiz: avval eng og'riqli joy — ko'pincha ombor yoki ishlab chiqarish — keyin qolganlari. Shunda ishlab chiqarish to'xtamaydi va xodimlar tizimga asta-sekin o'rganadi.",
            "Halol ogohlantirish: ERP — og'ir loyiha. U faqat hujjat aylanmasi tartibli bo'lgan korxonada ishlaydi. Agar ombordan tovar hujjatsiz chiqsa va ish haqi qora naqd berilsa, tizim bu tartibsizlikni tuzatmaydi, faqat ko'rsatib qo'yadi. Shuning uchun biz avval jarayonni tartibga solishni taklif qilamiz, keyin dasturlashni.",
        ],
    },

    definition: {
        term: "ERP tizimi nima?",
        text:
            "ERP tizimi — korxonaning xaridlar, ombor, ishlab chiqarish, sotuv, moliya va kadrlar jarayonlarini bitta ma'lumotlar bazasida birlashtirib boshqaradigan dastur. Har bir ma'lumot bir marta kiritiladi va barcha bo'limlarda bir xil ko'rinadi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir tarifga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifga ham kiradi.",
        items: [
            "Bepul konsultatsiya va korxona jarayonlari tahlili",
            "Jarayon xaritasi: material va hujjat harakati sxemasi",
            "Ma'lumotlar bazasi strukturasini loyihalash",
            "Figma'da interfeys dizayni va prototip",
            "Ombor qoldiqlari va nomenklaturani ko'chirish",
            "Rollar, kirish huquqlari va filial kesimlari",
            "Serverga o'rnatish, domen va HTTPS himoyasi",
            "Har kunlik zaxira nusxa va tiklash tartibi",
            "Bo'lim boshliqlari uchun alohida o'qitish sessiyalari",
            "Texnik hujjat va administrator qo'llanmasi",
            "Git repozitoriysi va kodning to'liq mulkchiligi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "ERP korxonaga nima beradi",
        sub: "ERP — shunchaki dastur emas, boshqaruv usuli. Quyida u aniq nimani hal qiladi.",
        items: [
            {
                t: "Bitta haqiqat manbasi",
                d: "Ombor, sotuv va buxgalteriya bitta bazadan o'qiydi. «Sizda bir raqam, bizda boshqa» degan bahs tugaydi, chunki raqam bitta joyda turadi va bir marta kiritiladi.",
            },
            {
                t: "Tannarx aniq hisoblanadi",
                d: "Xom ashyo, ish haqi, energiya va logistika xarajati har bir mahsulotga yig'iladi. Qaysi mahsulot foyda keltirayotgani, qaysi biri zarar bilan sotilayotgani raqam bilan ko'rinadi.",
            },
            {
                t: "Ombor nazorat ostida",
                d: "Qoldiq real vaqtda yangilanadi, inventarizatsiya bir necha soatda tugaydi. Kamomad, ortiqcha zaxira va muddati o'tayotgan partiyalar tizimning o'zida ogohlantirish bo'lib chiqadi.",
            },
            {
                t: "Ishlab chiqarish rejalashtiriladi",
                d: "Buyurtma, xom ashyo, bosqichlar, tayyor mahsulot — zanjir to'liq ko'rinadi. Sexlarning yuklamasi va muddat oldindan hisoblanadi, kechikish sababi esa keyin emas, o'sha kuni ma'lum bo'ladi.",
            },
            {
                t: "Rahbar uchun shaffoflik",
                d: "Boshqaruv panelida sotuv, qarzdorlik, ombor qoldig'i va ishlab chiqarish yuklamasi turadi. Hisobot so'rab bo'lim boshlig'ini kutish shart emas — ma'lumot doim yangi.",
            },
            {
                t: "Yo'qotishlar ko'rinadi",
                d: "Brak, ortiqcha sarf, hujjatsiz chiqim va muddati o'tgan tovar alohida hisoblanadi. Ko'pincha ERP birinchi yilning o'zida shu yo'qotishlar hisobiga qaytib keladi.",
            },
            {
                t: "O'sishga tayyorlik",
                d: "Yangi filial, ombor yoki mahsulot yo'nalishi qo'shilganda tizim kengayadi. Jarayonni yana Excel jadvallariga qaytarish yoki yangi dastur qidirish kerak bo'lmaydi.",
            },
            {
                t: "Tekshiruvga tayyor hujjat",
                d: "Kirim, chiqim va ichki harakat hujjatlari tizimda saqlanadi. Audit yoki soliq tekshiruvida hujjat qidirish o'rniga sana bo'yicha filtr qo'yasiz.",
            },
            {
                t: "Xarid to'g'ri rejalashtiriladi",
                d: "Tizim sarf tezligi va minimal qoldiqqa qarab nima, qachon va qancha sotib olish kerakligini ko'rsatadi. Bu ham tovarsiz qolishni, ham omborda muzlab qolgan pulni kamaytiradi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar qiladi",
        h: "Qanaqa korxonalar ERP quradi",
        sub: "Jarayoni murakkablashgan va Excel bilan boshqarib bo'lmay qolgan tashkilotlar.",
        items: [
            {
                t: "Ishlab chiqarish korxonalari",
                d: "Xom ashyo, retsept va kalkulyatsiya, ishlab chiqarish bosqichlari, brak hamda tayyor mahsulot hisobi.",
            },
            {
                t: "Ulgurji savdo va distribyutsiya",
                d: "Bir nechta ombor, dilerlar, individual narx ro'yxatlari, qarzdorlik va yetkazib berish nazorati.",
            },
            {
                t: "Qurilish va montaj",
                d: "Obyektlar bo'yicha smeta, material sarfi, pudratchilar va bajarilgan ish aktlari bo'yicha hisob.",
            },
            {
                t: "Qishloq xo'jaligi va qayta ishlash",
                d: "Mavsumiy xarid, saqlash sharoiti, qayta ishlash bosqichlari va partiyalar bo'yicha kuzatuv.",
            },
            {
                t: "Logistika va transport",
                d: "Avtopark, yoqilg'i sarfi, marshrutlar, ta'mirlash va har bir reys bo'yicha xarajat hisobi.",
            },
            {
                t: "Ko'p filialli tarmoqlar",
                d: "Filiallar o'rtasida tovar harakati, markazlashgan narx siyosati va yagona konsolidatsiyalangan hisobot.",
            },
            {
                t: "Dori va oziq-ovqat distribyutsiyasi",
                d: "Partiya, seriya raqami va yaroqlilik muddati bo'yicha qat'iy hisob hamda marshrutli yetkazib berish.",
            },
            {
                t: "Mebel va buyurtma asosidagi ishlab chiqarish",
                d: "Har bir buyurtma uchun alohida kalkulyatsiya, material sarfi, montaj jadvali va o'lchov bosqichi nazorati.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "ERP tizimi narxi — uchta tarif",
        sub: "Narxlar oshkora va bir martalik. Foydalanuvchi soni uchun oylik to'lov olinmaydi.",
        note:
            "Yakuniy hisob-kitob bepul jarayon tahlilidan keyin, modullar va integratsiyalar ro'yxatiga qarab tasdiqlanadi. To'lov modullar bo'yicha bosqichma-bosqich amalga oshiriladi — birinchi modul ishga tushmaguncha butun summa so'ralmaydi. Server va bulut xarajati (odatda oyiga 500 ming so'mdan) narxga kirmaydi. Savol bo'lsa qo'ng'iroq qiling: +998 90 954 12 62.",
        tiers: [
            {
                name: "Ombor",
                tagline: "Ombor va sotuv moduli",
                price: "40 000 000",
                priceNote: "so'mdan",
                term: "8–12 hafta",
                best: "Ombor qoldig'ini tartibga solish va kamomadni to'xtatish",
                features: [
                    "Nomenklatura, o'lchov birliklari va shtrix-kodlar",
                    "Kirim, chiqim, ko'chirish va hisobdan chiqarish hujjatlari",
                    "Bir nechta ombor va javon bo'yicha qoldiq hisobi",
                    "Ta'minotchilar bazasi va xarid buyurtmalari",
                    "Sotuv: hisob-faktura, yuk xati, qaytarish",
                    "Inventarizatsiya va kamomad hisoboti",
                    "Mijozlar bo'yicha qarzdorlik nazorati",
                    "Shtrix-kod skaneri bilan ishlash",
                    "Rollar, kirish huquqlari va amallar jurnali",
                    "O'qitish hamda 6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Ishlab chiqarish",
                tagline: "Ombor, ishlab chiqarish va moliya",
                price: "75 000 000",
                priceNote: "so'mdan",
                term: "16–26 hafta",
                best: "Ishlab chiqarishni rejalashtirish va tannarxni aniq bilish",
                featured: true,
                features: [
                    "Ombor tarifidagi barcha imkoniyatlar",
                    "Retsept va texnologik karta, normalar bo'yicha sarf",
                    "Ishlab chiqarish buyurtmasi va bosqichlar bo'yicha kuzatuv",
                    "Tannarx hisobi: material, ish haqi, ustama xarajatlar",
                    "Sexlar yuklamasi va ishlab chiqarish rejasi",
                    "Brak, qayta ishlash va chiqindi hisobi",
                    "Moliya: kassa, bank, to'lov kalendari, byudjet",
                    "1C yoki buxgalteriya dasturi bilan ikki tomonlama integratsiya",
                    "Rahbar uchun boshqaruv paneli va KPI ko'rsatkichlari",
                    "Filiallar va yuridik shaxslar kesimida hisobot",
                ],
            },
            {
                name: "Korporativ",
                tagline: "Holding darajasidagi yechim",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Holdinglar, ko'p yuridik shaxsli va murakkab integratsiyali korxonalar",
                features: [
                    "HR moduli: shtat, tabel, ish haqi hisobi",
                    "Byudjetlashtirish va reja-fakt tahlili",
                    "Dilerlar va ta'minotchilar uchun B2B portal",
                    "Ombor xodimlari uchun mobil ilova va TSD qurilmalari",
                    "Sun'iy intellekt: talab bashorati va zaxira optimizatsiyasi",
                    "Bir nechta valyuta va konsolidatsiyalangan hisobot",
                    "Ma'lumotlarni o'z serveringizda joylashtirish (on-premise)",
                    "Xavfsizlik auditi va kelishilgan SLA bo'yicha qo'llab-quvvatlash",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "ERP tizimi qanday quriladi",
        sub: "Oltita bosqich. ERP birdaniga emas, modullar bo'yicha ishga tushadi — bu eng xavfsiz yo'l.",
        steps: [
            {
                t: "Jarayon tahlili",
                time: "2–4 hafta",
                d: "Ombor, ishlab chiqarish va buxgalteriya bo'limlarida bo'lamiz: material qanday harakatlanadi, qanday hujjat yoziladi, qayerda ma'lumot yo'qoladi. Natija — jarayon xaritasi va muammolar ro'yxati.",
            },
            {
                t: "Texnik topshiriq va modullar navbati",
                time: "1–2 hafta",
                d: "Modullar, hisob-kitob qoidalari, hujjat shakllari va hisobotlar yozma tasdiqlanadi. Qaysi modul birinchi ishga tushishi shu yerda hal qilinadi — odatda eng og'riqlisi.",
            },
            {
                t: "Dizayn va ma'lumotlar bazasi",
                time: "2–3 hafta",
                d: "Baza strukturasi loyihalanadi va Figma'da interfeys tayyorlanadi. Ombor xodimlari prototipni sinab ko'radi: bir kunda yuz marta bosiladigan tugma qulay bo'lishi kerak.",
            },
            {
                t: "Modullarni dasturlash",
                time: "6–20 hafta",
                d: "Modullar navbat bilan yoziladi, har biri alohida topshiriladi va ishga tushadi. Shu tarzda korxona butun tizimni kutmaydi — foyda birinchi oylardanoq keladi.",
            },
            {
                t: "Ma'lumot ko'chirish va parallel ish",
                time: "2–4 hafta",
                d: "Qoldiqlar, nomenklatura va kontragentlar ko'chiriladi. Bir oygacha eski va yangi hisob parallel yuritiladi, raqamlar solishtiriladi va farq sababi topiladi.",
            },
            {
                t: "Ishga tushirish va kuzatuv",
                time: "6 oy",
                d: "Tizim to'liq ishga tushadi. Birinchi oylarda hisobot aniqligi kuzatiladi, xodimlar savollariga javob beriladi va aniqlangan xatoliklar bepul tuzatiladi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz qurgan korxona tizimlari",
        sub: "Har bir tizim noldan qurilgan: jarayon tahlili, dizayn va dasturlash biz tomonimizdan bajarilgan.",
        cta: "Barcha loyihalar",
        slugs: ["grandpharm", "tezlift", "befitpro", "family-group"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "ERP tizimlari bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "ERP tizimi yaratish qancha turadi?",
                a: "Narxlar 40 000 000 so'mdan boshlanadi. Bu summaga ombor va sotuv moduli kiradi: nomenklatura, kirim-chiqim hujjatlari, qoldiqlar, ta'minotchilar va qarzdorlik nazorati. Ishlab chiqarish, tannarx va moliya qo'shilsa, narx 75 000 000 so'mdan boshlanadi. Aniq raqam bepul jarayon tahlilidan keyin, modullar ro'yxatiga qarab beriladi.",
            },
            {
                q: "ERP ishlab chiqish qancha vaqt oladi?",
                a: "Ombor moduli 8–12 haftada, ishlab chiqarish va moliya bilan to'liq tizim 16–26 haftada topshiriladi. Lekin siz butun muddatni kutmaysiz: modullar navbat bilan ishga tushadi, birinchisi odatda 2–3 oyda real ishlashni boshlaydi. Muddat korxona hajmiga, nomenklatura kattaligiga va integratsiyalar soniga bog'liq. 1C ulanishi odatda 2–3 hafta qo'shadi.",
            },
            {
                q: "ERP va CRM o'rtasidagi farq nima?",
                a: "CRM mijoz va sotuv bilan ishlaydi: lidlar, voronka, bitimlar va menejerlar hisoboti. ERP esa butun korxonani qamraydi: xaridlar, ombor, ishlab chiqarish, moliya va kadrlar. Ko'p loyihada ERP ichida CRM moduli ham bo'ladi. Agar asosiy muammo sotuvda bo'lsa, CRM'dan boshlash arzonroq va tezroq.",
            },
            {
                q: "Bizda 1C bor, ERP kerakmi?",
                a: "1C asosan buxgalteriya va soliq hisobi uchun kuchli, lekin ishlab chiqarish rejasi, sexlar yuklamasi va operativ ombor boshqaruvi uchun ko'pincha qulay emas. Biz 1C'ni almashtirishni taklif qilmaymiz — uni saqlab qolib, ERP bilan bog'laymiz. Buxgalteriya 1C'da qoladi, operativ boshqaruv esa ERP'ga o'tadi.",
            },
            {
                q: "ERP'ni butun korxonaga birdan joriy qilish shartmi?",
                a: "Yo'q, biz buni tavsiya ham qilmaymiz. Barcha modullarni bir kunda yoqish eng ko'p uchraydigan xato: xodimlar chalkashadi, ishlab chiqarish sekinlashadi va loyiha ishonchni yo'qotadi. Biz eng og'riqli moduldan boshlaymiz, uni bir-ikki oy real ishda sinab ko'ramiz, xatolarini tuzatamiz, keyin keyingisiga o'tamiz. Bu yo'l uzunroq, lekin xavfi ancha past.",
            },
            {
                q: "Ombor qoldiqlarini eski tizimdan ko'chira olasizmi?",
                a: "Ha. Excel, 1C yoki boshqa dasturdan nomenklatura, qoldiqlar, kontragentlar va narx ro'yxatlari ko'chiriladi. Ko'chirish barcha tariflar narxiga kiradi. Ko'chirishdan oldin nomenklatura tozalanadi: takror pozitsiyalar birlashtiriladi, o'lchov birliklari yagona standartga keltiriladi. Ko'chirish odatda inventarizatsiya kunida bajariladi — shunda boshlang'ich qoldiq haqiqatga to'liq mos tushadi.",
            },
            {
                q: "Xodimlar ERP'ga qarshilik qilsa nima bo'ladi?",
                a: "Bu deyarli har loyihada uchraydi va sababi odatda interfeys emas — nazorat. Shuning uchun biz bo'lim boshliqlarini tahlil bosqichidayoq jalb qilamiz: ular tizimni birga loyihalasa, keyin uni himoya qiladi. Bundan tashqari, har bir rol uchun alohida o'qitish va qisqa video-qo'llanma tayyorlaymiz.",
            },
            {
                q: "Ma'lumotlar qayerda saqlanadi?",
                a: "Joyni siz tanlaysiz: biz tavsiya qilgan bulut serverida yoki korxonaning o'z serverida. Ishlab chiqarish korxonalari ko'pincha ikkinchi variantni tanlaydi. Ikkala holatda ham baza sizga tegishli, HTTPS shifrlash, rollar bo'yicha kirish cheklovi va har kunlik zaxira nusxa sozlanadi. Kim qaysi hujjatni o'zgartirgani amallar jurnalida qoladi va o'chirilmaydi.",
            },
            {
                q: "Kod kimga tegishli bo'ladi?",
                a: "Sizga. Loyiha sizning Git repozitoriyingizda olib boriladi, topshirishda barcha kod, baza sxemasi, texnik hujjat va server kirish huquqlari to'liq o'tadi. Bu shartnomada alohida band bilan yoziladi. Kelajakda ichki IT bo'limingiz yoki boshqa jamoa tizimni davom ettira oladi — bizga texnik jihatdan bog'lanib qolmaysiz.",
            },
            {
                q: "ERP qachon o'zini oqlamaydi?",
                a: "Agar korxonada hujjat aylanmasi tartibsiz bo'lsa — tovar hujjatsiz chiqsa, sarf normalari yo'q bo'lsa — ERP muammoni hal qilmaydi, faqat ko'rsatib qo'yadi. Shuningdek, oborot kichik va nomenklatura 200–300 pozitsiyadan oshmasa, yaxshi sozlangan ombor dasturi yoki CRM arzonroq yechim bo'ladi. Bunday holatda biz halol aytamiz va kichikroq loyihani taklif qilamiz.",
            },
        ],
    },

    cta: {
        h: "Korxonangizni bitta bazaga yig'amizmi?",
        p: "Bepul konsultatsiyada ombor, ishlab chiqarish va moliya jarayonlaringizni ko'rib chiqamiz, qaysi moduldan boshlash foydali ekanini aytamiz va aniq narx bilan muddatni yozma beramiz. Telefon: +998 90 954 12 62.",
        button: "Bepul konsultatsiya olish",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Grandpharm uchun qurilgan ERP va logistika ekotizimi boshqaruv paneli ekrani",
            caption: "Grandpharm — marshrutizatsiya, ichki boshqaruv tizimi va Telegram bot bitta ekotizimda.",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "Tez Lift korxonasi uchun servis arizalari va ehtiyot qismlar ombori moduli",
            caption: "Tez Lift — servis arizalari, brigadalar va ehtiyot qismlar ombori bitta tizimda.",
        },
        {
            src: "/assets/img/projects/befitpro.webp",
            alt: "BEFIT PRO yetkazib berish tizimi ombor qoldiqlari va buyurtmalar moduli",
            caption: "BEFIT PRO — buyurtmalar, ombor qoldiqlari va yetkazib berish marshrutlari nazorati.",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Family Group kompaniyasi uchun moliya va hisobotlar boshqaruv paneli",
            caption: "Family Group — moliya, qarzdorlik va bo'linmalar kesimidagi hisobotlar.",
        },
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "ELMA tizimi orqali korxona xodimlarini ERP modullari bo'yicha o'qitish ekrani",
            caption: "ELMA — xodimlarni ichki tizim va yangi modullar bo'yicha o'qitish hamda bilimni tekshirish.",
        },
    ],

    related: ["crm-tizimlar", "biznes-avtomatlashtirish", "veb-ilovalar", "mobil-ilova"],
};

const ru = {
    meta: {
        title: "ERP-системы — склад, производство и финансы в одной системе",
        description:
            "Разработка ERP-систем: склад, производство, финансы и отчётность в единой базе. От 40 млн сум, модули поэтапно, интеграция с 1С.",
        keywords: [
            "ERP-системы",
            "разработка ERP",
            "система управления предприятием",
            "складская программа",
            "учёт производства",
            "расчёт себестоимости",
            "интеграция с 1С",
            "стоимость ERP",
            "ERP Ташкент",
        ],
    },

    hero: {
        eyebrow: "ERP-системы",
        h1: "ERP-системы — склад, производство и финансы в единой системе",
        lead:
            "Продажи в Excel, склад в тетради, бухгалтерия в 1С? ERP собирает всё предприятие в одну базу: от закупки до склада, от производства до продажи и финансов. Каждая цифра вводится один раз и одинаково видна во всех отделах.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "200+ сданных проектов",
            "Модули запускаются поэтапно",
            "Интеграция с 1С и банком",
            "Код и база полностью ваши",
        ],
    },

    intro: {
        h: "Что такое ERP-система и что она даёт предприятию",
        p: [
            "ERP (Enterprise Resource Planning) — система, которая управляет всеми ресурсами предприятия в одной программе. Если CRM работает только с клиентом и продажей, то ERP шире: закупки, склад, производство, финансы, кадры и отчётность ведутся в одной базе данных и связаны между собой.",
            "На многих предприятиях картина сегодня такая. Отдел продаж работает в таблице Excel, склад ведёт учёт в тетради или отдельной программе, бухгалтерия сидит в 1С, а производство держится на памяти начальника цеха. В итоге каждый отчёт собирается вручную, цифры не сходятся, и руководитель ждёт три дня, чтобы принять решение.",
            "ERP закрывает именно этот разрыв. Когда товар уходит со склада, остаток уменьшается сам; когда сырьё передано в производство, оно само попадает в себестоимость; когда клиент оплатил, задолженность закрывается автоматически. Никто не переносит цифру из одной таблицы в другую — значит, и ошибиться при переносе негде.",
            "Innobek не продаёт готовую «коробочную» ERP. Мы разбираем реальный процесс вашего предприятия, строим систему под него и запускаем модули поэтапно: сначала самое больное место — чаще всего склад или производство, — затем остальные. Так производство не останавливается, а сотрудники привыкают к системе постепенно.",
            "Честное предупреждение: ERP — тяжёлый проект. Он работает только там, где документооборот уже упорядочен. Если товар уходит со склада без документов, а зарплата выдаётся в конверте, система не исправит этот беспорядок — она лишь сделает его видимым. Поэтому мы сначала предлагаем навести порядок в процессах и только потом браться за разработку.",
        ],
    },

    definition: {
        term: "Что такое ERP-система?",
        text:
            "ERP-система — программа, которая объединяет закупки, склад, производство, продажи, финансы и кадры предприятия в одной базе данных. Каждый показатель вводится один раз и одинаково отображается во всех подразделениях.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в каждый тариф по умолчанию",
        sub: "Это не платные дополнения — всё перечисленное есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и разбор процессов предприятия",
            "Карта процесса: схема движения материалов и документов",
            "Проектирование структуры базы данных",
            "Дизайн интерфейса и прототип в Figma",
            "Перенос складских остатков и номенклатуры",
            "Роли, права доступа и разрезы по филиалам",
            "Установка на сервер, домен и защита HTTPS",
            "Ежедневное резервное копирование и порядок восстановления",
            "Отдельные обучающие сессии для руководителей отделов",
            "Техническая документация и руководство администратора",
            "Git-репозиторий и полное владение кодом",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем нужно",
        h: "Что ERP даёт предприятию",
        sub: "ERP — не просто программа, а способ управления. Ниже — что именно она решает.",
        items: [
            {
                t: "Единый источник правды",
                d: "Склад, продажи и бухгалтерия читают одну базу. Спор «у вас одна цифра, у нас другая» заканчивается, потому что цифра хранится в одном месте и вводится один раз.",
            },
            {
                t: "Точная себестоимость",
                d: "Сырьё, зарплата, энергия и логистика относятся на каждое изделие. В цифрах видно, какой продукт приносит прибыль, а какой продаётся в минус.",
            },
            {
                t: "Склад под контролем",
                d: "Остаток обновляется в реальном времени, инвентаризация занимает несколько часов. О недостаче, излишних запасах и партиях с истекающим сроком система предупреждает сама.",
            },
            {
                t: "Производство планируется",
                d: "Заказ, сырьё, этапы, готовая продукция — цепочка видна целиком. Загрузка цехов и сроки считаются заранее, а причина задержки видна в тот же день, а не задним числом.",
            },
            {
                t: "Прозрачность для руководителя",
                d: "На панели управления — продажи, задолженность, складские остатки и загрузка производства. Не нужно ждать отчёта от начальника отдела: данные всегда свежие.",
            },
            {
                t: "Потери становятся видны",
                d: "Брак, перерасход, списания без документов и просроченный товар считаются отдельно. Часто ERP окупается уже в первый год именно за счёт сокращения этих потерь.",
            },
            {
                t: "Готовность к росту",
                d: "При добавлении филиала, склада или нового направления система расширяется. Не придётся возвращать процесс в таблицы Excel или искать другую программу.",
            },
            {
                t: "Документы готовы к проверке",
                d: "Приход, расход и внутренние перемещения хранятся в системе. Вместо поисков бумаг во время аудита или налоговой проверки вы ставите фильтр по датам.",
            },
            {
                t: "Закупки планируются правильно",
                d: "Система показывает, что, когда и в каком объёме закупать, опираясь на скорость расхода и минимальный остаток. Это сокращает и простои без товара, и объём денег, замороженных на складе.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Каким предприятиям нужна ERP",
        sub: "Организациям, чьи процессы усложнились и уже не помещаются в Excel.",
        items: [
            {
                t: "Производственные предприятия",
                d: "Сырьё, рецептуры и калькуляции, этапы производства, учёт брака и готовой продукции.",
            },
            {
                t: "Оптовая торговля и дистрибуция",
                d: "Несколько складов, дилеры, индивидуальные прайсы, контроль задолженности и доставки.",
            },
            {
                t: "Строительство и монтаж",
                d: "Учёт по объектам: сметы, расход материалов, подрядчики и акты выполненных работ.",
            },
            {
                t: "Сельское хозяйство и переработка",
                d: "Сезонные закупки, условия хранения, этапы переработки и отслеживание по партиям.",
            },
            {
                t: "Логистика и транспорт",
                d: "Автопарк, расход топлива, маршруты, ремонты и учёт затрат по каждому рейсу.",
            },
            {
                t: "Сети с несколькими филиалами",
                d: "Перемещение товара между филиалами, централизованная ценовая политика и единая консолидированная отчётность.",
            },
            {
                t: "Дистрибуция лекарств и продуктов",
                d: "Строгий учёт по партии, серии и сроку годности, а также маршрутная доставка.",
            },
            {
                t: "Мебель и производство под заказ",
                d: "Отдельная калькуляция на каждый заказ, расход материалов, график монтажа и контроль этапа замера.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость ERP-системы — три тарифа",
        sub: "Цены открытые и разовые. Ежемесячная плата за количество пользователей не взимается.",
        note:
            "Окончательный расчёт подтверждается после бесплатного разбора процессов, исходя из списка модулей и интеграций. Оплата идёт поэтапно, по модулям — весь бюджет до запуска первого модуля вносить не нужно. Стоимость сервера и облака (обычно от 500 тысяч сум в месяц) в цену не входит. Вопросы — по телефону +998 90 954 12 62.",
        tiers: [
            {
                name: "Склад",
                tagline: "Модуль склада и продаж",
                price: "40 000 000",
                priceNote: "сум и выше",
                term: "8–12 недель",
                best: "Навести порядок в остатках и остановить недостачу",
                features: [
                    "Номенклатура, единицы измерения и штрих-коды",
                    "Документы прихода, расхода, перемещения и списания",
                    "Учёт остатков по нескольким складам и ячейкам",
                    "База поставщиков и заказы на закупку",
                    "Продажи: счёт-фактура, накладная, возврат",
                    "Инвентаризация и отчёт по недостачам",
                    "Контроль задолженности по клиентам",
                    "Работа со сканером штрих-кодов",
                    "Роли, права доступа и журнал действий",
                    "Обучение и 6 месяцев технической поддержки",
                ],
            },
            {
                name: "Производство",
                tagline: "Склад, производство и финансы",
                price: "75 000 000",
                priceNote: "сум и выше",
                term: "16–26 недель",
                best: "Планировать производство и точно знать себестоимость",
                featured: true,
                features: [
                    "Все возможности тарифа «Склад»",
                    "Рецептуры и технологические карты, расход по нормам",
                    "Производственный заказ и отслеживание по этапам",
                    "Расчёт себестоимости: материалы, зарплата, накладные расходы",
                    "Загрузка цехов и план производства",
                    "Учёт брака, переработки и отходов",
                    "Финансы: касса, банк, платёжный календарь, бюджет",
                    "Двусторонняя интеграция с 1С или бухгалтерской программой",
                    "Панель руководителя с показателями KPI",
                    "Отчётность в разрезе филиалов и юридических лиц",
                ],
            },
            {
                name: "Корпоративный",
                tagline: "Решение уровня холдинга",
                price: "По договорённости",
                priceNote: "индивидуально",
                term: "По проекту",
                best: "Холдинги, компании с несколькими юрлицами и сложными интеграциями",
                features: [
                    "HR-модуль: штат, табель, расчёт заработной платы",
                    "Бюджетирование и план-фактный анализ",
                    "B2B-портал для дилеров и поставщиков",
                    "Мобильное приложение и ТСД для складских сотрудников",
                    "Искусственный интеллект: прогноз спроса и оптимизация запасов",
                    "Несколько валют и консолидированная отчётность",
                    "Размещение данных на вашем сервере (on-premise)",
                    "Аудит безопасности и поддержка по согласованному SLA",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как строится ERP-система",
        sub: "Шесть этапов. ERP запускается не разом, а модулями — это самый безопасный путь.",
        steps: [
            {
                t: "Разбор процессов",
                time: "2–4 недели",
                d: "Мы работаем в отделах склада, производства и бухгалтерии и смотрим, как движется материал, какие документы оформляются, где теряются данные. Результат — карта процесса и список проблем.",
            },
            {
                t: "ТЗ и очередь модулей",
                time: "1–2 недели",
                d: "Модули, правила расчётов, формы документов и отчёты фиксируются письменно. Здесь же решается, какой модуль запускается первым — обычно самый болезненный.",
            },
            {
                t: "Дизайн и база данных",
                time: "2–3 недели",
                d: "Проектируем структуру базы и готовим интерфейс в Figma. Складские сотрудники тестируют прототип: кнопка, на которую нажимают сто раз в день, должна быть удобной.",
            },
            {
                t: "Разработка модулей",
                time: "6–20 недель",
                d: "Модули пишутся по очереди, каждый сдаётся и запускается отдельно. Так предприятие не ждёт всю систему целиком — польза появляется уже в первые месяцы.",
            },
            {
                t: "Перенос данных и параллельная работа",
                time: "2–4 недели",
                d: "Переносим остатки, номенклатуру и контрагентов. До месяца старый и новый учёт ведутся параллельно, цифры сверяются, и по каждому расхождению находится причина.",
            },
            {
                t: "Запуск и наблюдение",
                time: "6 месяцев",
                d: "Система запускается полностью. В первые месяцы мы следим за точностью отчётов, отвечаем на вопросы сотрудников и бесплатно исправляем найденные ошибки.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Системы для предприятий, которые мы построили",
        sub: "Каждая система сделана с нуля: разбор процессов, дизайн и разработка выполнены нами.",
        cta: "Все проекты",
        slugs: ["grandpharm", "tezlift", "befitpro", "family-group"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на самые частые вопросы об ERP-системах.",
        items: [
            {
                q: "Сколько стоит разработка ERP-системы?",
                a: "Цены начинаются от 40 000 000 сум. В эту сумму входит модуль склада и продаж: номенклатура, документы прихода и расхода, остатки, поставщики и контроль задолженности. С производством, себестоимостью и финансами стоимость начинается от 75 000 000 сум. Точная цифра называется после бесплатного разбора процессов, исходя из списка модулей.",
            },
            {
                q: "Сколько времени занимает разработка ERP?",
                a: "Складской модуль сдаётся за 8–12 недель, полная система с производством и финансами — за 16–26 недель. Но ждать весь срок не нужно: модули запускаются по очереди, и первый обычно начинает реально работать через 2–3 месяца. Срок зависит от размера предприятия и количества интеграций.",
            },
            {
                q: "Чем ERP отличается от CRM?",
                a: "CRM работает с клиентом и продажей: заявки, воронка, сделки и отчёты по менеджерам. ERP охватывает всё предприятие: закупки, склад, производство, финансы и кадры. Во многих проектах внутри ERP есть и модуль CRM. Если основная боль в продажах, начать с CRM дешевле и быстрее.",
            },
            {
                q: "У нас есть 1С — нужна ли ERP?",
                a: "1С сильна в бухгалтерском и налоговом учёте, но для плана производства, загрузки цехов и оперативного управления складом она часто неудобна. Мы не предлагаем заменять 1С — мы её сохраняем и связываем с ERP. Бухгалтерия остаётся в 1С, а оперативное управление переходит в ERP.",
            },
            {
                q: "Нужно ли внедрять ERP сразу на всё предприятие?",
                a: "Нет, и мы этого не рекомендуем. Включить все модули за один день — самая частая ошибка: сотрудники путаются, производство замедляется, и проект теряет доверие. Мы начинаем с самого болезненного модуля, обкатываем его, а затем переходим к следующему — шаг за шагом.",
            },
            {
                q: "Можно ли перенести складские остатки из старой системы?",
                a: "Да. Номенклатура, остатки, контрагенты и прайсы переносятся из Excel, 1С или другой программы. Перенос входит в стоимость всех тарифов. Перед переносом номенклатуру чистим: дублирующиеся позиции объединяем, единицы измерения приводим к единому стандарту. Сам перенос обычно делается в день инвентаризации — тогда стартовые остатки полностью совпадают с фактом.",
            },
            {
                q: "Что делать, если сотрудники сопротивляются ERP?",
                a: "Это встречается почти в каждом проекте, и причина обычно не в интерфейсе, а в контроле. Поэтому мы вовлекаем руководителей отделов уже на этапе разбора: если они проектируют систему вместе с нами, потом они же её и защищают. Плюс отдельное обучение и короткие видеоинструкции для каждой роли.",
            },
            {
                q: "Где хранятся данные?",
                a: "Место выбираете вы: рекомендованный нами облачный сервер или собственный сервер предприятия. Производственные компании чаще выбирают второй вариант. В обоих случаях база принадлежит вам, настраиваются шифрование HTTPS, ограничение доступа по ролям и ежедневное резервное копирование. Кто какой документ изменил, остаётся в журнале действий и не удаляется.",
            },
            {
                q: "Кому принадлежит код?",
                a: "Вам. Проект ведётся в вашем Git-репозитории, при сдаче полностью переходят код, схема базы, техническая документация и доступы к серверу. Этот пункт прописывается в договоре отдельно. В будущем систему сможет развивать ваш внутренний IT-отдел или другая команда — технической зависимости от нас не остаётся.",
            },
            {
                q: "Когда ERP не окупается?",
                a: "Если документооборот на предприятии беспорядочный — товар уходит без документов, норм расхода нет, — ERP не решит проблему, а только сделает её видимой. Также при небольшом обороте и номенклатуре до 200–300 позиций дешевле обойдётся хорошо настроенная складская программа или CRM.",
            },
        ],
    },

    cta: {
        h: "Соберём ваше предприятие в одну базу?",
        p: "На бесплатной консультации разберём процессы склада, производства и финансов, скажем, с какого модуля выгоднее начать, и письменно зафиксируем цену и срок. Телефон: +998 90 954 12 62.",
        button: "Получить бесплатную консультацию",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/projects/grandpharm.webp",
            alt: "Экран панели управления ERP и логистической экосистемы, построенной для Grandpharm",
            caption: "Grandpharm — маршрутизация, внутренняя система управления и Telegram-бот в одной экосистеме.",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "Модуль сервисных заявок и склада запчастей для компании Tez Lift",
            caption: "Tez Lift — сервисные заявки, бригады и склад запчастей в одной системе.",
        },
        {
            src: "/assets/img/projects/befitpro.webp",
            alt: "Модуль складских остатков и заказов системы доставки BEFIT PRO",
            caption: "BEFIT PRO — контроль заказов, складских остатков и маршрутов доставки.",
        },
        {
            src: "/assets/img/projects/family-group.webp",
            alt: "Панель управления финансами и отчётностью для компании Family Group",
            caption: "Family Group — финансы, задолженность и отчётность в разрезе подразделений.",
        },
        {
            src: "/assets/img/projects/elma-lms.webp",
            alt: "Экран обучения сотрудников предприятия работе с модулями ERP в системе ELMA",
            caption: "ELMA — обучение сотрудников работе во внутренней системе и проверка знаний по новым модулям.",
        },
    ],

    related: ["crm-tizimlar", "biznes-avtomatlashtirish", "veb-ilovalar", "mobil-ilova"],
};

const content = { uz, ru };

export default content;
